module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-02.e96101f2.svg";